/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Scope_Detail5Inputs */

const en_svc_backend_development_scope_detail5 = /** @type {(inputs: Svc_Backend_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Map endpoints, data flow, and integration points.`)
};

const ar_svc_backend_development_scope_detail5 = /** @type {(inputs: Svc_Backend_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حدد نقاط النهاية وتدفق البيانات ونقاط التكامل.`)
};

const bn_svc_backend_development_scope_detail5 = /** @type {(inputs: Svc_Backend_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এন্ডপয়েন্ট, ডেটা ফ্লো ও ইন্টিগ্রেশন পয়েন্ট ম্যাপ করুন।`)
};

const de_svc_backend_development_scope_detail5 = /** @type {(inputs: Svc_Backend_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpunkte, Datenfluss und Integrationspunkte zuordnen.`)
};

const es_svc_backend_development_scope_detail5 = /** @type {(inputs: Svc_Backend_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapear endpoints, flujo de datos y puntos de integración.`)
};

const fr_svc_backend_development_scope_detail5 = /** @type {(inputs: Svc_Backend_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartographiez les endpoints, le flux de données et les points d'intégration.`)
};

const pt_svc_backend_development_scope_detail5 = /** @type {(inputs: Svc_Backend_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapeie endpoints, fluxo de dados e pontos de integração.`)
};

const zh_svc_backend_development_scope_detail5 = /** @type {(inputs: Svc_Backend_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`梳理接口、数据流和集成点。`)
};

const tr_svc_backend_development_scope_detail5 = /** @type {(inputs: Svc_Backend_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uç noktaları, veri akışını ve entegrasyon noktalarını çıkarın.`)
};

const ru_svc_backend_development_scope_detail5 = /** @type {(inputs: Svc_Backend_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карта эндпоинтов, дата-флоу и точек интеграции.`)
};

const pl_svc_backend_development_scope_detail5 = /** @type {(inputs: Svc_Backend_Development_Scope_Detail5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpisz endpointy, przepływ danych i punkty integracji.`)
};

/**
* | output |
* | --- |
* | "Map endpoints, data flow, and integration points." |
*
* @param {Svc_Backend_Development_Scope_Detail5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_scope_detail5 = /** @type {((inputs?: Svc_Backend_Development_Scope_Detail5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Scope_Detail5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_scope_detail5(inputs)
	if (locale === "bn") return bn_svc_backend_development_scope_detail5(inputs)
	if (locale === "de") return de_svc_backend_development_scope_detail5(inputs)
	if (locale === "es") return es_svc_backend_development_scope_detail5(inputs)
	if (locale === "fr") return fr_svc_backend_development_scope_detail5(inputs)
	if (locale === "pt") return pt_svc_backend_development_scope_detail5(inputs)
	if (locale === "zh") return zh_svc_backend_development_scope_detail5(inputs)
	if (locale === "tr") return tr_svc_backend_development_scope_detail5(inputs)
	if (locale === "ru") return ru_svc_backend_development_scope_detail5(inputs)
	if (locale === "pl") return pl_svc_backend_development_scope_detail5(inputs)
	return en_svc_backend_development_scope_detail5(inputs)
});
export { svc_backend_development_scope_detail5 as "svc_backend-development_SCOPE_detail" }